import { useEffect, useState } from "react";
import { getCombos, getObjetivoEspecifico } from "../componentes/api.js";
import FormControlLabel from "@mui/material/FormControlLabel";
import AlertTitle from "@mui/material/AlertTitle";
import Alert from "@mui/material/Alert";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import SegParticipante from "./SegParticipante.jsx";

const Seguimiento = (props) => {
  const [listaProyectos, setListaProyectos] = useState([]);
  const [idProyecto, setIdProyecto] = useState("");
  const [objetivo, setObjetivo] = useState("");
  const [tipoParticipante, setTipoParticipante] = useState("2"); //Equipo de trabajo

  useEffect(() => {
    cargarCombos({ Tabla: "proyectos", Campo: "" }, "cboProyectos");
  }, []);

  const asignarDato = (event) => {
    event.preventDefault();
    if (event.target.name === "cboProyectos") {
      setIdProyecto(event.target.value);
      cargarObjetivos(event.target.value);
    } else if (event.target.name === "tipoParticipante") {
      setTipoParticipante(event.target.value);
    }
  };

  const cargarCombos = async (datos, cbo) => {
    try {
      const response = await getCombos(datos);
      setListaProyectos(response.data);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar los Combos",
        error,
      ]);
    }
  };

  const cargarObjetivos = async (idProyecto) => {
    try {
      /**** Carga el Objetivo específico del Proyecto ***/
      const response = await getObjetivoEspecifico(idProyecto);
      setObjetivo(response.data.ObjetivoEspecifico);
    } catch (error) {
      props.mostrarMsg([
        "ERROR",
        "Ocurrio un error al cargar el Objetivo del Proyecto ",
        error,
      ]);
    }
  };

  return (
    <div className="container-fluid card shadow mt-2">
      <div className="row">
        <Alert severity="success">
          <AlertTitle>
            <strong>SEGUIMIENTO AL PROYECTO</strong>
          </AlertTitle>
          Seleccione un Proyecto y realice Seguimiento de éste
        </Alert>
      </div>

      <div className="row form-floating mb-3 mt-3 mx-2">
        <select
          type="text"
          className="form-control"
          name="cboProyectos"
          value={idProyecto}
          onChange={(event) => {
            asignarDato(event);
          }}
        >
          <option key="0" value="0">
            Por favor seleccione un Proyecto...
          </option>
          {listaProyectos.map((reg) => {
            return (
              <option key={reg.Id} value={reg.Id} label={reg.Nbre}>
                {" "}
                {reg.Nbre}{" "}
              </option>
            );
          })}
        </select>
        <label htmlFor="cboProyectos">Seleccione un Proyecto</label>
      </div>

      <div className="row">
        <Alert severity="info">
          <AlertTitle>
            <strong>OBJETIVO ESPECIFICO DEL PROYECTO</strong>
          </AlertTitle>
          {objetivo || "Seleccione un Proyecto para ver el Objetivo"}
        </Alert>
      </div>

      <div className="card-footer mt-3 mb-3">
        <FormControl>
          <FormLabel id="demo-form-control-label-placement">
            Seleccione a quien realizará Seguimiento
          </FormLabel>
          <RadioGroup
            row
            aria-labelledby="demo-form-control-label-placement"
            name="tipoParticipante"
            defaultValue="2"
          >
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="Equipo de Trabajo"
              onChange={asignarDato}
            />

            <FormControlLabel
              value="3"
              control={<Radio />}
              label="Participante (Beneficiario)"
              onChange={asignarDato}
            />
          </RadioGroup>
        </FormControl>
      </div>

      {idProyecto !== "" && (
        <SegParticipante
          id={props.idUsuario}
          idProyecto={idProyecto}
          tipoParticipante={tipoParticipante}
          mostrarMsg={props.mostrarMsg}
        />
      )}
    </div>
  );
};

export default Seguimiento;
